import React from 'react';
import ReactPaginate from 'react-paginate';
import { number, func } from 'prop-types';
import { ReactComponent as ChevronLeft } from 'assets/icons/chevron-left.svg';
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg';

import './style.css';

const Pagination = ({ totalPages, onPageChange, currentPage }) => {
  return (
    <ReactPaginate
      data-testid="pagination"
      previousLabel={
        <ChevronLeft className="w-2 h-3 fill-current text-gray-400" />
      }
      nextLabel={
        <ChevronRight className="w-2 h-3 fill-current text-gray-400" />
      }
      pageCount={totalPages}
      onPageChange={onPageChange}
      forcePage={currentPage - 1}
      containerClassName="pagination-container"
      activeClassName="active"
      disabledClassName="disabled"
    />
  );
};

Pagination.propTypes = {
  totalPages: number,
  onPageChange: func.isRequired,
  currentPage: number,
};

Pagination.defaultProps = {
  currentPage: 1,
  totalPages: 1,
};

export default Pagination;
